export const MOBILE_WIDTH = 768
export const TABLET_WIDTH = 1024
